function mainRender() {
    $(function () {
        $('#root').css('zoom', 'normal')
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)

        window.addEventListener(
            'resize',
            (function () {
                var timer
                return function () {
                    if (timer) clearTimeout(timer)
                    timer = setTimeout(function () {
                        $('#root').css('zoom', 'normal')
                        let scale = document.body.clientWidth / 1080
                        $('#root').css('zoom', scale)
                    }, 100)
                }
            })()
        )
        // 生成随机时间
        function generateRandomTime() {
            var hours = Math.floor(Math.random() * 15) + 1
            var minutes = Math.floor(Math.random() * 60)
            var seconds = Math.floor(Math.random() * 60)
            //总共的毫秒数
            var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

            return targetTime
        }
        function TimeDown(value) {
            //倒计时的总秒数
            var totalSeconds = parseInt(value / 1000)
            //取模（余数）
            var modulo = totalSeconds % (60 * 60 * 24)
            //小时数
            var hours = Math.floor(modulo / (60 * 60))
            modulo = modulo % (60 * 60)
            //分钟
            var minutes = Math.floor(modulo / 60)
            //秒
            var seconds = modulo % 60

            hours = hours.toString().length == 1 ? '0' + hours : hours
            minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
            seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

            //输出到页面
            $('.sp_hour').html(hours)
            $('.sp_minute').html(minutes)
            $('.sp_second').html(seconds)
            //延迟一秒执行自己
            if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
            } else {
                setTimeout(function () {
                    TimeDown(value - 1000)
                }, 1000)
            }
        }
        TimeDown(generateRandomTime())
        let imgList = [
            'https://cdn.shopify.com/s/files/1/0600/3209/0165/files/20240927-pro-0.png?v=1727428215',
            'https://cdn.shopify.com/s/files/1/0600/3209/0165/files/20240927-pro-0.png?v=1727428215',
            'https://cdn.shopify.com/s/files/1/0600/3209/0165/files/20240927-pro-0.png?v=1727428215',
            'https://wintrre.com/cdn/shop/files/2_ec0de95b-7ef3-40a9-925a-8d359b886916.png?v=1782209334&width=493',
            'https://wintrre.com/cdn/shop/files/3_783df959-f1dd-4f59-9c19-ea4e3e720b2b.png?v=1782209353&width=493',
            'https://wintrre.com/cdn/shop/files/1_8cd75707-679f-4315-8d06-7788e8a5af9f.png?v=1782209370&width=493'

        ]
        let prods = window.product
        function getCur() {
            let color = $('#Size div.active').attr('data-val')
            let type = $('#Color div.active').attr('data-val')
            return prods.filter(
                item =>
                    item.option1 == color
            )[0]
        }
        function changePrice() {
            let num = $('#calcNumber').val()
            let price = ((getCur().price * num) / 100).toFixed(2).replace('.',',')
            let compare = ((getCur().compare_at_price * num) / 100).toFixed(2).replace('.',',')
            // price = (price + '').replace('.', ',')
            // compare = (compare + '').replace('.', ',')
            $('#new').html(price)
            $('#old').html(compare)
            let off_font =
                100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
            $('.font-off').html(off_font)
        }

        // 头部固定
        $('header').addClass('stiky')
        $(document).scroll(function (e) {
            setTimeout(function () {
                $('header').addClass('stiky')
            }, 50)
        })
        // 轮播
        new Swiper('.mySwiper', {
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: {
                delay: 4000,
                stopOnLastSlide: false,
                disableOnInteraction: false,
            },
        })
        new Swiper('.mySwiper2', {
            slidesPerView: 2,
            spaceBetween: 38,
            centeredSlides: true,
            loop: true, //循环滚动
            freeMode: true,
            speed: 6500, //匀速时间
            autoplay: {
                delay: 0,
                stopOnLastSlide: false,
                disableOnInteraction: false,
            },
        })
        new Swiper('.mySwiper3', {
            slidesPerView: 'auto',
            spaceBetween: 0,
            centeredSlides: true,
            loop: true, //循环滚动
            freeMode: true,
            speed: 6500, //匀速时间
            autoplay: {
                delay: 0,
                stopOnLastSlide: false,
                disableOnInteraction: false,
            },
        })
        // function changePrice() {
        //   const productObj = window.product.find(i=>i.id==$("#Size .active").attr("data-id"))
        //   const price =  productObj.price*$("#calcNumber").val()/100
        //   const cPrice = productObj.compare_at_price*$("#calcNumber").val()/100
        //   console.log(window.product,$("#Size .active").attr("data-id"),productObj)
        //   $("#new").text( (price).toFixed(2))
        //   $('#old').html((cPrice).toFixed(2))
        // }
        //加减
        $('.reduce').click(function () {
            let input = $(this).siblings('input')[0]
            let num = Number(input.value) - 1
            if (num > 0) {
                input.value = num
            }
            var number = Number($('#calcNumber').val())
            // $('#new').html((number * Number(39.99)).toFixed(2))
            // $('#old').html((number * Number(79.99)).toFixed(2))
            changePrice()
        })
        $('.add').click(function () {
            let input = $(this).siblings('input')[0]
            let num = Number(input.value) + 1
            input.value = num
            var number = Number($('#calcNumber').val())
            // $('#new').html((number * Number(39.99)).toFixed(2))
            // $('#old').html((number * Number(79.99)).toFixed(2))
            changePrice()
        })
        $('.option').click(function () {
            $(this).siblings().removeClass('active')
            $(this).addClass('active')
            let sizeIndex = $('#Size .option.active').index()
            let colorIndex = $('#Color .option.active').index()
            let _index = sizeIndex + colorIndex * 3
            if (colorIndex == 1) {
                $('.sp-free-text').hide()
            } else {
                $('.sp-free-text').show()
            }
            console.log(_index, '666')
            $('.top-product img').attr('src', imgList[sizeIndex])
            changePrice()

        })
        $(".sp-btn-style").click(() => {
            let num = $('#calcNumber').val()
            let id = getCur().id
            window.location.href = '/cart/' + id + ':' + num
        })
        addCart()
        function addCart() {
            // 加入购物车
            $('#addCart').click(function () {
                // do something here
                var number =
                    Number($('#calcNumber').val())
                var data = {
                    id: getCur().id,
                    quantity: number
                };
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: data,
                    success: function () {
                        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
                            $("#cardNum").html(result.item_count);
                        });
                    },
                    dataType: "json",
                });
                var img = $('.top-product img')
                var flyer = img[0].cloneNode(true)
                flyer.classList.add('clone')
                $('.product-part').append(flyer)
                $('.clone').css({
                    width: img.width(),
                    height: img.height(),
                    position: 'fixed',
                    top: img[0].offsetTop,
                    left: img.offset().left,
                    'z-index': '99',
                })
                var offset = $('.sp-cart')[0].getBoundingClientRect()
                $('.sp-cart').addClass('shake')
                setTimeout(() => {
                    $('.sp-cart').removeClass('shake')
                }, 1000)
                let finish = $('.sp-cart')
                $('.clone').animate(
                    {
                        top: finish[0].offsetTop,
                        left: finish[0].offsetLeft + finish.width() / 2,
                        width: 50, // 结束时的大小，根据需要调整
                        height: 50, // 结束时的大小，根据需要调整
                        opacity: 0.4,
                    },
                    1000,
                    'linear',
                    function () {
                        $(this).animate(
                            {
                                width: 0,
                                height: 0,
                                opacity: 0,
                            },
                            0,
                            function () {
                                $(this).detach() // 完成动画后移除克隆的图片
                            }
                        )
                    }
                )
            })
        }
    })
    function lazyLoadImages() {
        // 懒加载
        const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
        const config = {
            rootMargin: '0px 0px 1300px 0px',
            threshold: 0,
        }

        const lazyLoadObserver = new IntersectionObserver(function (
            entries,
            observer
        ) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    // 当图片进入视口时
                    const image = entry.target
                    const dataSrc = image.getAttribute('data-src')
                    image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
                    lazyLoadObserver.unobserve(image) // 停止观察该图片
                }
            })
        },
            config)

        images.forEach(function (image) {
            lazyLoadObserver.observe(image) // 开始观察每个图片
        })
    }

    function preloadImages(imageArray) {
        // 预加载
        // 检查数组数据结构
        if (Array.isArray(imageArray[0])) {
            // 处理二维数组
            imageArray.forEach((subArray) => {
                subArray.forEach((url) => {
                    const img = new Image()
                    img.src = url
                })
            })
        } else {
            // 处理一维数组
            imageArray.forEach((url) => {
                const img = new Image()
                img.src = url
            })
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        lazyLoadImages()

        // preloadImages(imagesOneDim)
        // preloadImages(imagesTwoDim)

        // 找到所有跳转套餐的锚点链接
        var links = document.querySelectorAll('a[href^="#shopping"]')
        links.forEach(function (link) {
            link.addEventListener('click', function (event) {
                event.preventDefault() // 阻止默认的跳转行为
                // var targetElement = document.getElementById('shopping');
                // if (targetElement) {
                //     targetElement.scrollIntoView({ behavior: 'smooth' });
                // } // 方式一
                const targetElement = document.getElementById('shopping') // 获取跳转目标节点
                const offsetTop =
                    targetElement.offsetTop -
                    $('.time-part').height() -
                    $('.sp-header-top').height()
                window.scroll({
                    top: offsetTop * $('div#root').css('zoom') + 100,
                    behavior: 'smooth', // 使用 smooth 实现平滑滚动
                }) // 方式二
            })
        })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
        console.log('Android')
    } else if (isIOS) {
        console.log('iOS')
    } else if (isPC) {
        console.log('PC')
    } else {
        $('.sp_system').css('letter-spacing', '-4px')
    }
}

mainRender()
